module.exports = __webpack_public_path__ + "img/x-box-image-detail-1.b411eaf1.png";